import * as pubsub from "pubsub-js";
import { DocumentItemViewModel, LoadedExtendedInfo } from "client/Api/Documents/SharePoint/common";
import { DocumentsViewContainerViewModelExtendedInfo } from "client/Api/Documents/SharePoint/sharepointDocuments";

export enum SharePointEvent {
	// When a event in the namespace is fired
	TopLevel = "document.sharepoint",

	// When a document is added or replaced
	AddedOrReplaced = "document.sharepoint.addedOrReplaced",
	// When a document is deleted
	Deleted = "document.sharepoint.deleted",
	// When a document is renamed
	Renamed = "document.sharepoint.renamed",

	// When the extended info for a site was retrieved
	SiteExtendedInfoLoaded = "document.sharepoint.siteExtendedInfoLoaded"
}

export type SiteExtendedInfoLoadedEventData = {
	containerId: string;
	extendedInfo: LoadedExtendedInfo<DocumentsViewContainerViewModelExtendedInfo>;
};

type Data<T extends SharePointEvent> =
	T extends SharePointEvent.TopLevel ? undefined :
	T extends SharePointEvent.AddedOrReplaced ? DocumentItemViewModel :
	T extends SharePointEvent.Deleted ? readonly DocumentItemViewModel[] :
	T extends SharePointEvent.Renamed ? { newDocument: DocumentItemViewModel; } :
	T extends SharePointEvent.SiteExtendedInfoLoaded ? SiteExtendedInfoLoadedEventData :
	never;

export const subscribe: <T extends SharePointEvent>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends SharePointEvent>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
